import {
  PosthogActions,
  PosthogEvents,
} from 'components/PostHog/PosthogEvents';
import { formatUserId } from 'components/PostHog/utils';
import { User } from 'shared/types/user';
import posthog from 'posthog-js';
import { ShouldRenderType } from '../types';

export const showDisplayFooter = (
  shouldRender: ShouldRenderType,
  showHeaderAndFooter: boolean,
) => shouldRender('footerSection') && showHeaderAndFooter;

export const trackPosthog = (
  /* eslint-disable @typescript-eslint/no-explicit-any */
  phase: any,
  placementID: string,
  user: User | null,
) => {
  posthog.capture(PosthogEvents.UserActions, {
    action: PosthogActions.ViewPlacement,
    phase,
    property: {
      id: placementID,
    },
    user: user?.email,
    userId: formatUserId(user?.id ?? 0),
  });
};
